/**
 * Created by allen on 2017/8/1.
 */

var _ = require('underscore');
var dataHelper = require('./dataHelper');

var templete = {
  "ComBase": {
    "color": "0xFFFFFFFF",
    "borderColor": "0xFF666666",
    "borderVisible": true,
    "status": "MsEnabled",
    "opacity": 1,
    "isAutoSize": false,
    "locked": false,
    "sizeLocked": false,
    "canMove": true,
    "remarkText": "",
    "externalURL": "",
    "isCommentCom": false,
    "isShow": true,
    "alias": "",
    "caption": "",
    "verticalScrollbarShow": false,
    "verticalScrollbarProgress": 0,
    "horizontalScrollbarShow": false,
    "horizontalScrollbarProgress": 0,
    "rotation": 0
  },
  "ComTextBase": {
    "textFontFamily": "",
    "useDefaultTextSize": true,
    "textStyles": "[]",
    "textAlign": "HaLeft",
    "textVAlign": "VaMiddle",
    "textColor": "0xFF000000",
    "textSize": 12,
    "selectedIndex": 0,
    "selectedColor": "0xFF41C7DB",
    //"isAutoTextColor": true,
    "lineSpacingMultiple": 1,
    "text": "",
    "textWordWrap": true,
    "textPadding": 0
  },
  "Button": {
    "BaseID": "ComTextBase",
    "textAlign": "HaCenter",
    "textSize": 14,
    "radius": 6,
    "radiusIsPercent": false,
    "buttonStatus": "BsNormal",
    "thickness": 1,
    "isAutoTextColor": false
  },
  "Shape": {
    "BaseID": "ComTextBase",
    "dashMode": "SdSolid",
    "shapeBorderType": "SbRectangle",
    "triangleType": "TdZero",
    "thickness": 1,
    "radiusIsPercent": false,
    "radius": 0,
    "textAlign": "HaCenter",
    "borderMode": "[bmLeft,bmTop,bmRight,bmBottom]"
  },
  "Circle": {
    "BaseID": "Shape"
  },
  "Polygon": {},
  "Triangle": {
    "triangleType": "ttNormal",
    "triangleDirection": "TdZero",
    "thickness": 1,
    "dashMode": "SdSolid"
  },
  "Icon": {
    "color": "0xFF666666",
    "URL": "",
    "flipHorizontal": false,
    "flipVertical": false,
    "rotationAngle": "TdZero"
  },
  "Image": {
    "borderVisible": false,
    "flipHorizontal": false,
    "flipVertical": false,
    "rotationAngle": "TdZero",
    "URL": "",
    "fitMode": "fmStretch",
    "clipShapeType": "SbRectangle",
    "showText": true,
    "radius": 0,
    "radiusIsPercent": false
  },
  "CoverFlow": {
    "URL": ""
  },
  "Gif": {
    "URL": ""
  },
  "Label": {
    "BaseID": "ComTextBase",
    "isAutoSize": true,
    "textSize": 14,
    "color": "0x00000000"
  },
  "TextInput": {
    "BaseID": "ComTextBase",
    "canInput": true,
    "inputModel": "emText",
    "placeHolder": "",
    "textVAlign": "VaMiddle",
    "textSize": 14,
    "radiusIsPercent": false
  },
  "LabelTextInput": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "textDirection": "tdLeft"
  },
  "TextArea": {
    "BaseID": "ComTextBase",
    "textSize": 14,
    "textVAlign": "VaTop",
    "borderVisible": false,
    "color": "0x00FFFFFF"
  },
  "RadioButton": {
    "BaseID": "ComTextBase",
    "textSize": 14,
    "textVAlign": "VaTop",
    "textDirection": "tdRight",
    "state": "MfSelected",
    "size": 15
  },
  "RadioButtonGroup": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "textDirection": "tdRight",
    "rowGap": 10,
    "columnGap": 10,
    "columnCount": 1,
    "size": 13,
    "itemHeight": 16
  },
  "CheckBox": {
    "BaseID": "ComTextBase",
    "state": "MfSelected",
    "textDirection": "tdRight",
    "gap": 0,
    "size": 0,
    "textSize": 14
  },
  "CheckBoxGroup": {
    "BaseID": "ComTextBase",
    "textSize": 14,
    "rowGap": 10,
    "columnGap": 10,
    "textDirection": "tdRight",
    "size": 0,
    "itemHeight": 19,
    "columnCount": 1,
    "selectedIndex": -1,
    "textVAlign": "VaTop"
  },
  "IconButton": {
    "size": 24,
    "buttonStyle": "buttonStyle",
    "iconColor": "0xFF444444",
    "rotationAngle": "TdZero",
    "FlipHorizontal": false,
    "FlipHorizontal": false
  },
  "IconLabel": {
    "BaseID": "ComTextBase",
    "iconDirection": "MiTextBottom",
    "size": 24,
    "rotationAngle": "TdZero",
    "FlipHorizontal": false,
    "FlipHorizontal": false
  },
  "AlarmIcon": {
    "size": 28,
    "rotationAngle": "TdZero",
    "FlipHorizontal": false,
    "FlipHorizontal": false
  },
  "HSlider": {
    "sliderColor": "0xFF666666",
    "trackColor": "0xFF666666",
    "progress": 30,
    "sliderShapeType": "SIncisive",
    "state": "MsEnabled"
  },
  "VSlider": {
    "sliderColor": "0xFF666666",
    "trackColor": "0xFF666666",
    "progress": 30,
    "sliderShapeType": "SIncisive",
    "state": "MsEnabled"
  },
  "Tree": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "borderStyle": false,
    "iconSize": 13,
    "iconColor": "0xFF666666",
    "iconStyle": "isSquare",
    "iconVisible": true,
    "itemHeight": 32,
    "checkboxvisible": false,
    "treelinevisible": false
  },
  "IPad2": {
    "direction": "SmVert",
    "color": "0xFFF8F9F9",
    "borderColor": "0xFF999999"
  },
  "TabletPC2": {
    "direction": "SmVert",
    "color": "0xFFF8F9F9",
    "borderColor": "0xFF999999"
  },
  "IPhone2": {
    "direction": "SmVert",
    "color": "0xFFF8F9F9",
    "borderColor": "0xFF999999",
    "isTransparent": false,
    "fullScreen": false
  },
  "Android": {
    "direction": "SmVert",
    "color": "0xFFF8F9F9",
    "borderColor": "0xFF999999",
    "isTransparent": false,
    "fullScreen": false
  },
  "IPad": {
    "direction": "SmVert"
  },
  "TabletPC": {
    "direction": "SmVert"
  },
  "IPhone": {
    "direction": "SmVert",
    "phoneType": "PtAllWhite",
    "isTransparent": false,
    "fullScreen": false
  },
  "Phone": {
    "direction": "SmVert",
    "phoneType": "PtAllWhite",
    "isTransparent": false,
    "fullScreen": false
  },
  "PageControl": {},
  "PageControlEx": {
    "gap": 30,
    "size": 10,
    "columnCount": 5,
    "selectedIndex": 3,
    "shapeType": "stRound",
    "color": "0xFF999999",
    "selectedColor": "0xFF41C7DB",
    "borderVisible": false
  },
  "ColumnChart": {},
  "ColumnChartEx": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "axisvisible": true,
    "borderStyle": true
  },
  "BarChart": {},
  "BarChartEx": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "axisvisible": true,
    "borderStyle": true
  },
  "PieChart": {},
  "PieChartEx": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "axisvisible": true,
    "borderStyle": true
  },
  "LineChart": {},
  "LineChartEx": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "axisvisible": true,
    "borderStyle": true
  },
  "Graffiti": {
    "color": "0xFFFF0000",
    "isCommentCom": true,
    "strokeThickness": 6,
    "pointList": ""
  },
  "Line": {
    "BaseID": "ComTextBase",
    "color": "0xFF666666",
    "textAlign": "HaCenter",
    "textVAlign": "VaTop",
    "controlPoint": "",
    "startPoint": "",
    "endPoint": "",
    "thickness": 1,
    "dashMode": "SdSolid",
    "textBackgroundColor": "0xFFFFFFFF",
    "textBorderColor": "0xFF666666",
    "showStartArrow": 0,
    "showEndArrow": 0,
    "isCurved": true,
    "isTextPosCenter": true
  },
  "Arrow": {
    "BaseID": "ComTextBase",
    "isCommentCom": true,
    "color": "0xFF666666",
    "textAlign": "HaCenter",
    "textVAlign": "VaTop",
    "controlPoint": "",
    "startPoint": "",
    "endPoint": "",
    "thickness": 1,
    "dashMode": "SdSolid",
    "textBackgroundColor": "0xFFFFFFFF",
    "textBorderColor": "0xFF666666",
    "showStartArrow": 0,
    "showEndArrow": 0,
    "isCurved": false,
    "isTextPosCenter": true
  },
  "StickyNote": {
    "BaseID": "ComTextBase",
    "color": "0xFFF1C232",
    "isCommentCom": true,
    "textVAlign": "VaTop",
    "isShowTabBar": true
  },
  "CallOut": {
    "BaseID": "ComTextBase",
    "isCommentCom": true,
    "textVAlign": "VaTop"
  },
  "HCurly": {
    "BaseID": "ComTextBase",
    "color": "0xFF666666",
    "isCommentCom": true,
    "textAlign": "HaCenter",
    "textVAlign": "VaTop",
    "direction": "DrTop"
  },
  "VCurly": {
    "BaseID": "ComTextBase",
    "color": "0xFF666666",
    "isCommentCom": true,
    "textAlign": "HaCenter",
    "textVAlign": "VaTop",
    "direction": "DrLeft"
  },
  "RedX": {
    "isCommentCom": true
  },
  "ScratchOut": {
    "isCommentCom": true
  },
  "DataGrid": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "showVLine": true,
    "showHLine": false,
    "showHeader": true,
    "interlaceColor": "0xFFEEEEEE",
    "itemHeight": 25,
    "isInterlace": true,
    "separatorColor": "0xFF666666",
    "headerHeight": 22,
    "headerColor": "0xFF999999",
    "headerTextColor": "0xFF000000",
    "columnRatio": "",
    "selectedTextColor": "0xFF000000"
  },
  "HotSpot": {},
  "BreadCrumbs": {
    "BaseID": "ComTextBase",
    "textColor": "0xFF256BA9",
    "textVAlign": "VaTop",
    "gap": 12
  },
  "List": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "textPadding": 10,
    "itemHeight": 25,
    "isInterlace": false,
    "interlaceColor": "0xFFEEEEEE",
    "separatorColor": "0xFF666666",
    "showSeparator": false
  },
  "ToolTip": {
    "BaseID": "ComTextBase",
    "textAlign": "HaCenter",
    "tipCornerDirection": "AdLeftBottom"
  },
  "Link": {
    "BaseID": "ComTextBase",
    "isAutoSize": true,
    "textColor": "0xFF0E6C9C",
    "textVAlign": "VaTop",
    "textStyles": "[fsUnderline]",
  },
  "LinkBar": {
    "BaseID": "ComTextBase",
    "color": "0xFF666666",
    "textColor": "0xFF085394",
    "textVAlign": "VaTop",
    "gap": 12
  },
  "ModalScreen": {
    "color": "0x66000000"
  },
  "ColorPicker": {
    "color": "0xFF2B78E4"
  },
  "NumericStepper": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop"
  },
  "DateTimePicker": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop"
  },
  "Menu": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "itemHeight": 25,
    "separatorColor": "0xFF666666"
  },
  "MenuBar": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop"
  },
  "SiteMap": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop"
  },
  "CircleProgressBar": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "value": 70,
    "thickness": 5,
    "indicatorColor": "0xFF41C7DB",
    "trackColor": "0xFFDDDDDD",
  },
  "ProgressBar": {
    "BaseID": "ComTextBase",
    "progress": 30,
    "barStyle": "MfBar",
    "indicatorColor": "0xFF999999",
    "trackColor": "0xFFFFFFFF",
  },
  "ButtonBar": {
    "BaseID": "ComTextBase",
    "color": "0x00FFFFFF",
    "textVAlign": "VaTop",
    "thickness": 1,
    "showHover": false,
    "hoveredColor": "0x4041C7D6",
    "selectedTextColor": "0xFF000000"
  },
  "Search": {
    "BaseID": "ComTextBase",
    "state": "CsEnabled",
    "radius": "100",
    "radiusIsPercent": true
  },
  "Alert": {
    "BaseID": "ComTextBase",
    "textAlign": "HaCenter",
    "textVAlign": "VaTop",
    "selection": "MBNone"
  },
  "ComboBox": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "state": "MsEnabled",
    "unfolded": false,
    "baseHeight": 36
  },
  "CompositeComboBox": {
    "rowCount": 5,
    "canInput": false,
    "baseHeight": 39,
    "textColor": "0xFF000000",
    "textSize": 12,
    "textStyles": "[]",
  },
  "Form": {
    "BaseID": "ComTextBase",
    "gap": 10
  },
  "QRCode": {},
  "Calendar": {},
  "VolumeSlider": {},
  "VideoPlayer": {},
  "Media_Control": {},
  "FormattingToolbar": {},
  "EditToolbar": {},
  "Map": {},
  "HSplitter": {},
  "VSplitter": {},
  "HRule": {
    "color": "0xFF666666",
    "thickness": 2
  },
  "VRule": {
    "color": "0xFF666666",
    "thickness": 2
  },
  "VerticalScrollbar": {
    "progress": 0
  },
  "HorizontalScrollBar": {
    "progress": 0
  },
  "GroupBox": {
    "BaseID": "ComTextBase"
  },
  "Tab": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "selectedColor": "0xFFFFFFFF",
    "direction": "VdTop",
    "tabPosition": "HaLeft",
    "tabStyle": "csSquare",
    "radius": 0,
    "tabColor": "0xFFDDDDDD",
    "tabEdge": "0",
    "tabHeight": 18,
    "selectedTextColor": "0xFF000000"
  },
  "VerticalTabBar": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "selectedColor": "0xFFFFFFFF",
    "direction": "HdLeft",
    "tabDirection": "SmHori",
    "radius": 0,
    "tabColor": "0xFFDDDDDD",
    "tabEdge": "0",
    "tabHeight": 25,
    "selectedTextColor": "0xFF000000"
  },
  "Accordion": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "itemHeight": 29,
    "separatorColor": "0xFF666666",
    "showSeparator": true
  },
  "TitleWindow": {
    "BaseID": "ComTextBase",
    "showMin": false,
    "showMax": false,
    "showClose": false,
    "showDrag": false,
    "topHeight": 30,
    "bottomHeight": 24
  },
  "BrowserWindow": {},
  "Switch": {
    "isOpen": true,
    "onColor": "0xFF41C7DB",
    "offColor": "0xFFC0C0C0"
  },
  "SwitchIOS": {
    "borderVisible": false,
    "isOpen": true,
    "onColor": "0xFF4AD662",
    "offColor": "0xFFDDDDDD"
  },
  "Avatar(Mobile)": {},
  "StatusBar(IOS)": {
    "color": "0xFF000000",
    "ForegroundColor": "0xFFFFFFFF",
    "IsAutoTextColor": true
  },
  "StatusBar(Android)": {
    "color": "0xFF000000",
    "ForegroundColor": "0xFFFFFFFF",
    "IsAutoTextColor": true
  },
  "NavigationBar": {
    "color": "0xFF000000",
    "ForegroundColor": "0xFFFFFFFF",
    "IsAutoTextColor": true
  },
  "Keyboard": {
    "direction": "SmVert",
    "keyboardType": "ktLetter"
  },
  "TimePicker": {},
  "TimePicker2": {},
  "QuickContact": {},
  "Top ActionBar": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "showMenu": true,
    "showBack": true,
    "iconColor": "0xFF000000"
  },
  "Contexual ActionBar": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
  },
  "Slider": {
    "color": "0xFF41C7DB",
    "progress": 30
  },
  "LetterNavigation": {},
  "Control PopOver": {
    "BaseID": "ComTextBase"
  },
  "Spinner": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop"
  },
  "ScopeBar": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "thickness": 1,
    "radius": 100,
    "radiusIsPercent": true,
    "showHover": false,
    "hoveredColor": "0x4041C7D6",
    "selectedTextColor": "0xFF000000"
  },
  "TextField": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaBottom",
    "showIcon": true,
    "canInput": true,
    "placeHolder": "",
    "inputModel": "emText"
  },
  "TableView": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "borderStyle": true,
    "itemHeight": 36,
    "iconSize": 24,
    "separatorColor": "0xFF666666",
    "showSeparator": true,
    "iconColor": "0xFF666666"
  },
  "Tabs": {
    "BaseID": "ComTextBase",
    "color": "0x00FFFFFF",
    "textVAlign": "VaTop",
    "thickness": 1,
    "indicatorPercentWidth": 100,
    "indicatorHeight": 3,
    "dividerPercentHeight": 50,
    "dividerColor": "0xFF666666",
    "selectedTextColor": "0xFF000000"
  },
  "PointyButton": {
    "BaseID": "ComTextBase",
    "textVAlign": "VaTop",
    "showMenu": false,
    "direction": 2
  },
  "Webcam": {},
  "AvatarEx": {
    "color": "0x70000000",
    "style": "ibsNone",
    "textDirection": "MiTextBottom",
    "iconSize": 24,
    "showText": true,
    "showAlarm": false,
    "AlarmColor": 0,
    "AlarmText": "",
    "avatartype": "Contact",
    "colorstyle": "asNormal",
    "avatarshapestyle": "asRect",
    "avatarbordcolor": "0xFF999999",
    "avatarcolor": "0xFFFFFFFF",
    "avatarcolorsetisenabled": false,
    "avatarshapestyleiscircle": false
  },
  "AvatarEx2": {
    "avatarType": "Contact",
    "avatarBackgroundColor": "0xFF999999",
    "avatarColorStyle": "asNormal",
    "avatarShapeStyle": "asRect",
    "avatarColor": "0xFFFFFFFF",
    "thickness": 2,
    "URL": ""
  },
  "IconButton2": {
    "color": "0xFF666666",
    "style": "ibsCircle",
    "textDirection": "MiTextBottom",
    "iconSize": 24,
    "showText": false,
    "showAlarm": false,
    "AlarmColor": 0,
    "AlarmText": "",
  },
  "IconLabel2": {
    "color": "0xFF666666",
    "style": "ibsNone",
    "textDirection": "MiTextBottom",
    "iconSize": 24,
    "showText": true,
    "showAlarm": false,
    "AlarmColor": 0,
    "AlarmText": "",
  },
  "AlarmIcon2": {
    "color": "0xFF666666",
    "style": "ibsNone",
    "textDirection": "MiTextBottom",
    "iconSize": 24,
    "showText": false,
    "showAlarm": true,
    "AlarmColor": 0,
    "AlarmText": "",
  },
  "PopupPanel": {
    "color": "0x70000000",
    "borderVisible": false,
    "isBackgroundFade": false,
    "aniType_Mobile": "aniFade",
    "aniType": "dnNone",
    "closeByClickMode": "cmClickOutSizeArea",
    "closeByKeyModes": "[kmEsc,kmEnter]",
    "isShowBackground": false,
    "delayBeforePopup": 0,
    "aniDuration": 200,
    "positionPolicy": "ppFree",
    "positionMargin": 0,
    "positionScreenMode": "psCenter",
    "positionComMode": "pcBottom"
  },
  "Panel": {
    "thickness": 1,
    "dashMode": "SdSolid"
  },
  "Border": {
    "locked": true,
    "thickness": 1,
    "dashMode": "SdSolid"
  },
  "PopupPanelContent": {
    "locked": true,
    "borderVisible": false
  },
  "PopupMenu": {
    "color": "0x70000000",
    "borderVisible": false,
    "isBackgroundFade": false,
    "aniType_Mobile": "aniNone",
    "aniType": "dnNone",
    "closeByClickMode": "cmClickAllArea",
    "closeByKeyModes": "[kmEsc,kmEnter]",
    "isShowBackground": false,
    "delayBeforePopup": 0,
    "aniDuration": 200,
    "positionPolicy": "ppFree",
    "positionMargin": 0,
    "positionScreenMode": "psCenter",
    "positionComMode": "pcBottom"
  },
  "AlertWindow": {
    "color": "0x70000000",
    "borderVisible": false,
    "isBackgroundFade": true,
    "aniType_Mobile": "aniFade",
    "aniType": "dnNone",
    "closeByClickMode": "cmClickOutSizeArea",
    "closeByKeyModes": "[kmEsc,kmEnter]",
    "isShowBackground": true,
    "delayBeforePopup": 0,
    "aniDuration": 200,
    "positionPolicy": "ppFree",
    "positionMargin": 0,
    "positionScreenMode": "psCenter",
    "positionComMode": "pcBottom"
  },
  "SlidingDrawer": {
    "color": "0x70000000",
    "borderVisible": false,
    "isBackgroundFade": true,
    "aniType_Mobile": "aniFade",
    "aniType": "dnNone",
    "closeByClickMode": "cmClickOutSizeArea",
    "closeByKeyModes": "[kmEsc,kmEnter]",
    "isShowBackground": true,
    "delayBeforePopup": 0,
    "aniDuration": 200,
    "positionPolicy": "ppFree",
    "positionMargin": 0,
    "positionScreenMode": "psCenter",
    "positionComMode": "pcBottom",
    "drawerSlideDirection": "sdLeft"
  },
  "ImageSlider": {
    "isAbandon": true,
    "aniType": "spaNone",
    "playInterval": 6000,
    "indicatorType": "SiRectangle",
    "indicatorDirection": "sidTop",
    "animate": "spaNone",
    "isAutoPlay": false
  },
  "ImageCarousel": {
    "color": "0x00FFFFFF",
    "borderVisible": false,
    "selectedIndex": 0,
    "aniType": "spaNone",
    "playInterval": 6000,
    "isAutoPlay": true,
    "indicatorDirection": "sidBottom",
    "indicatorType": "SiCircle",
    "indicatorColor": "0xFFFFFFFF",
    "isShowIndicator": true,
    "fitMode": "fmAutoFit"
  },
  "ImageBackground": {
    "color": "0x00000000",
    "borderVisible": false,
    "canMove": false,
    "URL": ""
  },
  "StackPanel": {
    "aniType": "spaNone"
  },
  "ContentPanel": {
    "borderVisible": false,
    "selectedIndex": 0,
    "aniType": "spaNone",
    "playInterval": 6000,
    "contentLayout": "clAbsolute",
    "canHoriScroll": false,
    "canVertScroll": true,
    "showScrollBars": true
  },
  "ScrollArea": {
    "borderVisible": false
  },
  "ScrollViewPort": {
    "color": "0x00000000",
    "borderVisible": false,
    "canMove": false
  },
  "ScrollView": {
    "canHoriScroll": false,
    "canVertScroll": true,
    "showScrollBars": true
  },
  "ScrollViewContentPanel": {
    "color": "0x00000000",
    "locked": true,
    "borderVisible": false,
    "borderColor": "0xFF000000"
  },
  "Repeater": {
    "borderVisible": false,
    "horiGap": 20,
    "vertGap": 20,
    borderColor: "#000000"
  },
  "Timer": {
    interval: 1000
  },
  "Tabel": {
    "textWordWrap": true
  }
}


function getTempleteByID(controlTypeID) {
  var prop = {};
  var propIDChain = [];
  var currentPropID = controlTypeID;
  var currentProp;
  var i;

  while (currentPropID && templete[currentPropID]) {

    propIDChain.push(currentPropID);
    currentProp = templete[currentPropID];
    currentPropID = currentProp.BaseID;
  }

  propIDChain.push("ComBase");        //推入所有组件的基属性

  for (i = propIDChain.length - 1; i >= 0; i--) {
    _.extend(prop, templete[propIDChain[i]]);
  }

  delete prop.BaseID;
  return prop;
};

exports.initComp = function (comp) {
  var templete;

  comp.x = parseInt(comp.x, 10);
  comp.y = parseInt(comp.y, 10);
  comp.h = parseInt(comp.h, 10);
  comp.w = parseInt(comp.w, 10);

  if (!comp.text || _.isEmpty(comp.text)) {
    comp.text = '';   // 组件保存时，如果字符串为空，该属性未保存。
  }
  if (comp.remarkText) {
    if (_.isEmpty(comp.remarkText)) {
      comp.remarkText = '';
    }

    comp.remarkText = dataHelper.decodeURI(comp.remarkText);
  }
  if (_.isEmpty(comp.externalURL)) {
    comp.externalURL = '';
  }
  if (_.isEmpty(comp.URL)) {
    comp.URL = '';
  }


  if (comp) {
    templete = getTempleteByID(comp.controlTypeID);
    for (var key in templete) {
      if (_.isUndefined(comp[key])) {
        comp[key] = dataHelper.convertValue(key, templete[key]);
      }
    }
  }
};


// WEBPACK FOOTER //
// ./src/helper/CompTemplete.js